import { createAxiosInstance } from '../utils/request';

// 创建文件专用的axios实例
const fileRequest = createAxiosInstance({
  baseURL: process.env.REACT_APP_API_FILE_URL || '/api'
});

// 单文件上传
export const uploadFile = (file, directory = 'files', keepOriginalName = false, checkDuplicate = true) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('directory', directory);
  formData.append('keepOriginalName', keepOriginalName);
  formData.append('checkDuplicate', checkDuplicate);

  return fileRequest({
    url: '/file/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// 多文件上传
export const uploadMultipleFiles = (files, directory = 'files', keepOriginalName = false, checkDuplicate = true) => {
  const formData = new FormData();
  files.forEach(file => {
    formData.append('files', file);
  });
  formData.append('directory', directory);
  formData.append('keepOriginalName', keepOriginalName);
  formData.append('checkDuplicate', checkDuplicate);

  return fileRequest({
    url: '/file/upload/multiple',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// 文件下载
export const downloadFile = (objectName) => {
  return fileRequest({
    url: '/file/download',
    method: 'get',
    params: { objectName },
    responseType: 'blob'
  });
};

/**
 * 获取OSS文件临时访问URL
 * @param {string} objectName 对象名称（完整路径）
 * @param {number} [expireTime=3600] URL过期时间（秒，默认1小时）
 * @returns {Promise} 包含文件URL的Promise
 */
export const getFileUrl = (objectName, expireTime = 3600) => {
  return fileRequest({
    url: '/file/url',
    method: 'get',
    params: {
      objectKey: objectName,
      expireTime: expireTime
    }
  });
};
